/**
 * repair · «почини плохой артефакт» before → after cards (S04 TD-06).
 *
 * Topic-fit practice for Bug Report quality writing: the student takes a raw
 * junior BR and repairs it field by field — sees the bad version («было»), taps
 * «Починить», and the professional version («стало») slides in with a note on
 * WHAT changed. A counter tracks repaired fields; a final verdict rewards the
 * full fix. Rehearses the 3 anti-patterns (AC-03) and the review skill — and is
 * deliberately a different shape from decompose / scDeck / storyBuilder.
 *
 * Markup contract (authored content · no-JS degradable — without this script each
 * `.rc-good` shows inline and the «Починить» buttons are hidden via CSS):
 *   <div class="rep">
 *     <div class="rep-head"><span class="ttl">Почини плохой Bug Report</span>
 *       <span class="rep-cnt">починено <b class="rep-num">0</b>/6</span></div>
 *     <div class="rep-intro">…</div>
 *     <div class="rep-list">
 *       <div class="rc">
 *         <div class="rc-field">Title</div>
 *         <div class="rc-bad"><span class="rc-badtag">было</span><span class="rc-badtxt">…</span></div>
 *         <div class="rc-act"><button type="button" class="rc-fixbtn">Починить</button></div>
 *         <div class="rc-good"><div class="rc-goodrow"><span class="rc-goodtag">стало</span>
 *           <span class="rc-goodtxt">…</span></div>
 *           <div class="rc-changed"><b>что изменилось:</b> …</div></div>
 *       </div>
 *       … cards …
 *     </div>
 *     <div class="rep-fin">…payoff (revealed when all repaired)…</div>
 *   </div>
 */

export function initRepair(root: HTMLElement): () => void {
  if (typeof document === 'undefined') return () => {};
  const cleanups: Array<() => void> = [];

  const reps = Array.from(root.querySelectorAll<HTMLElement>('.rep'));
  for (const rep of reps) {
    if (rep.dataset.repInit === '1') continue;
    rep.dataset.repInit = '1';
    rep.classList.add('rep-ready');

    const cards = Array.from(rep.querySelectorAll<HTMLElement>('.rc'));
    const numEl = rep.querySelector<HTMLElement>('.rep-num');
    const fin = rep.querySelector<HTMLElement>('.rep-fin');
    if (cards.length === 0) continue;

    let done = 0;

    for (const card of cards) {
      const btn = card.querySelector<HTMLButtonElement>('.rc-fixbtn');
      if (!btn) continue;
      const onFix = () => {
        if (card.classList.contains('done')) return;
        card.classList.add('done');
        done += 1;
        if (numEl) numEl.textContent = String(done);
        if (done === cards.length && fin) fin.classList.add('on');
      };
      btn.addEventListener('click', onFix);
      cleanups.push(() => btn.removeEventListener('click', onFix));
    }

    // StrictMode (dev) double-invoke safety (see scDeck.ts).
    cleanups.push(() => {
      rep.classList.remove('rep-ready');
      delete rep.dataset.repInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
